













import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IImportSource } from "@/models/imports";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import { LogoSize, LogoType } from "@/data/enums/logos";
import _ from "@/boot/lodash";

@Component({
  computed: {
    ...mapState({
      sources(state, getters) {
        return getters[`data/listArray`]({
          scope: this.dataScope,
          storeModule: DataModules.IMPORTS
        });
      }
    })
  }
})
export default class ImportSourceSelect extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public value!: IImportSource["id"] | null;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data
  public readonly dataScope = "$sources";
  public isLoading = true;
  public sources!: IImportSource[];

  // Life-cycle methods

  public created() {
    this.getSources();
  }

  public beforeDestroy() {
    this.binSources();
  }

  // Computed

  public get selectedSourceId(): IImportSource["id"] | null {
    return this.value;
  }

  public set selectedSourceId(sourceId) {
    this.$emit("input", sourceId);
    this.$emit("source", _.find(this.sources, ["id", sourceId]));
  }

  // Methods

  public async getSources(ignoreStored = false) {
    try {
      await this.$store.dispatch(`data/${DataModules.IMPORTS}/listSources`, {
        vm: this,
        scope: this.dataScope,
        ignoreStored
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
    }
  }

  public async binSources() {
    try {
      await this.$store.dispatch("data/binList", {
        scope: this.dataScope,
        storeModule: DataModules.IMPORTS,
        vm: this
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public getLogoSrc(source: IImportSource) {
    return this.$_.get(
      this.$_.find(source.logos || [], logo => {
        if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
          return true;
        return false;
      }),
      "url",
      null
    );
  }
}
